import React from 'react';
import timezones from './timezones.json';
import { Select3 } from '@weezevent/nacre';
import './timeZoneSelect.css';

export function TimeZoneSelect({ value, onChange, ...rest }) {
    let options = React.useMemo(() => timezones.map(v => ({ text: v, value: v })), [timezones]);
    return (
        <div className="timezone-select">
            <Select3 value={value} options={options} onChange={onChange} {...rest} />
        </div>
    );
}
